import { buildDropdownList } from '../app/app.helpers'
import {
  THIRD_PARTY_TOOLS_TYPE_FILTERS,
  EXTENSIONS_TAB_TYPE,
  EXTENSIONS_TAB_CONTENT_ID
} from '../../constants/extensions'
import { toKebabCase, trim } from '../string.helpers'
import { EXTENSIONS_URL } from '../../constants/navigation'

const buildThirdPartyToolTypes = (t) => {
  return buildDropdownList(
    THIRD_PARTY_TOOLS_TYPE_FILTERS,
    'extensions.third-party-tools-type-filters',
    t
  )
}

const fromExtensionsTabIdToType = (tabId) => {
  switch (tabId) {
    case EXTENSIONS_TAB_CONTENT_ID.EARN_OPTIONS:
      return EXTENSIONS_TAB_TYPE.EARN_OPTIONS
    default:
      return EXTENSIONS_TAB_TYPE.THIRD_PARTY_TOOLS
  }
}

const fromExtensionsTypeToTabId = (selectedTab) => {
  switch (selectedTab) {
    case EXTENSIONS_TAB_TYPE.EARN_OPTIONS:
      return EXTENSIONS_TAB_CONTENT_ID.EARN_OPTIONS
    default:
      return EXTENSIONS_TAB_CONTENT_ID.THIRD_PARTY_TOOLS
  }
}

const buildThirdPartyToolsData = (thirdPartyTools, toolsFilterType) => {
  if (toolsFilterType === THIRD_PARTY_TOOLS_TYPE_FILTERS.ALL) {
    return thirdPartyTools
  }
  return thirdPartyTools.filter(
    (record) => trim(toKebabCase(record?.metadata?.type)) === toolsFilterType
  )
}

const buildLoveBrandCardProps = (
  surveyId,
  { userSurveys, userSurveysLikesCount, id },
  onLikeUnlikeBrand
) => {
  return {
    onLikeUnlike: () => onLikeUnlikeBrand(surveyId, id),
    likesCount: userSurveysLikesCount?.[surveyId]?.[id],
    liked: userSurveys?.[surveyId]?.response?.[id]?.liked
  }
}

const sortOptionsByTitleASC = (options) => {
  if (!options || options.length === 0) {
    return []
  }
  return options?.sort((a, b) => a.title.localeCompare(b.title))
}

const buildExtensionsUrl = (activeTab) => {
  return `${EXTENSIONS_URL}/${activeTab}`
}

export {
  buildThirdPartyToolTypes,
  fromExtensionsTabIdToType,
  fromExtensionsTypeToTabId,
  buildThirdPartyToolsData,
  buildLoveBrandCardProps,
  sortOptionsByTitleASC,
  buildExtensionsUrl
}
